module.exports = __webpack_public_path__ + "static/media/mapping-consumer-data-img-002.7e37af32.jpg";